<div class="geofence-polygon-container">
    <div class="row">
        <div class="col-12">
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonButtonMsg" [isVisible]="AddPolygonSelected == 'create' && isPolygonButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container-top" [Mensaje]="polygonFinishMsg" [isVisible]="AddPolygonSelected == 'create' && !isPolygonButtonMsgVisible"></app-tooltip>
            <button [ngClass]="{'btnPin-polygon': AddPolygonSelected == 'create'}" class="btnPin edit-btn" mat-raised-button (click)="createPolygonPoints(true); this.fullScreen = false;">
                <p class="btn-label center-item"><mat-icon class="example-tab-icon">control_point</mat-icon>
                    Seleccionar Vertices
                </p>
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonEditButtonMsg" [isVisible]="isPolygonEditButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
            <button [ngClass]="{'btnPin-polygon': AddPolygonSelected == 'edit'}" class="btnPin" mat-raised-button (click)="editPolygonPoints()">
                <p class="btn-label center-item">
                    <mat-icon class="example-tab-icon">edit</mat-icon> Editar
                </p>
            </button>
        </div>
        <div class="col-6">
            <button class="btnPin" mat-raised-button (click)="deletePolygonPoints()"
                matTooltip="Herramienta de borrado de poligono" matTooltipPosition="right">
                <p class="btn-label center-item"><mat-icon class="example-tab-icon">delete</mat-icon> Borrar</p>
            </button>
        </div>
    </div>

</div>